import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Component from 'vue-class-component';


@Component({
  computed: mapGetters([
    'isOwner',
    'isMember',
    'isApprovedMember',
    'isWaiting',
    'getWallet',
    'getMemberCounter',
    'getTokenSymbol',
    'getTokenTotalSupply',
    'getFinStatementCounter',
    'getConnectedStatus',
    'getInitStatusToken',
    'getInitStatusOwners',
    'getInitStatusFirstOwner',
    'getCompanyInfo',
    'getCompanyUpdates',
    'getPendings',
    'getActiveOrderCounter',
    'isReader',
    'getMember',
    'getMembers',
    'getLegalDocuments',
    'ipfs',
    'getTokenInfo',
    'getDailyVolume',
    'getDailyHigh',
    'getChartData',
    'getOrders',
    'getLastTrade',
    'getTrades',
    'getActiveOrders',
    'getEthToUSDPrice',
    'getOneETHtoUSD',
    'getTokenBalance',
    'getOwners',
    'isUsedEscrow',
    'getTradeTransfersEscrow',
    'getTokenTransfersEscrow',
    'getTokenTransfers',
    'getFinStatements',
    'getWaitings',
    'getOtherAssets',
    'getCompanyEthereumWallet',
    'getCompanyEthereumBalance',
    'getCompanyBitcoinWallet',
    'getCompanyBitcoinBalance',
    'getCompanyBankWallet',
    'getCompanyName',
    'getCompanyBalance',
    'getCompanyWallet',
    'getVotings',
    'getVotes',
    'getMemberAvatar',
    'communications',
    'getActiveTradesList',
    'getSidebarLinks',
    'getBalance',
    'getOpenClose',
    'getBlockNumber',
    'sidebarForm',
    'getNetwork',
    'sidebarFormData',
    'isTreasuryWallet',
    'getBalances',
    'getMinTotal',
  ]),
  methods: {
    ...mapActions([
      'openClose',
      'getMembersDapp',
      'getTradesOfOrderDapp',
      'cancelMarketOrderDapp',
      'getChartDataExt',
      'getMarketCupExt',
      'getDailyHighExt',
      'getDailyVolumeExt',
      'clearChartData',
      'getOtherAssetsExt',
      'getVotingVotesDapp',
      'changeOwnerDapp',
      'addFirstOwnerDapp',
      'initiateParametersDapp',
      'isInitiatedTokenDapp',
      'closeSidebar',
      'initiateOwnersDapp',
      'addOwnersDapp',
      'setSideBarForm',
      'setSideBarForm',
      'getStripePublicExt',
      'purchaseStripeExt',
      'addCompanyInfoDapp'
    ]),
    ...mapMutations([
      'initializationPending',
      'resetOwners'
    ])
  },
})
export class Base extends Vue {
  public isOwner: any;
  public isMember: any;
  public isApprovedMember: any;
  public isWaiting: any;
  public getWallet: any;
  public getMemberCounter: any;
  public getTokenSymbol: any;
  public getTokenTotalSupply: any;
  public getFinStatementCounter: any;
  public getConnectedStatus: any;
  public getInitStatusToken: any;
  public getInitStatusOwners: any;
  public getInitStatusFirstOwner: any;
  public getCompanyInfo: any;
  public getCompanyUpdates: any;
  public getPendings: any;
  public getActiveOrderCounter: any;
  public isReader: any;
  public getMember: any;
  public getMembers: any;
  public getLegalDocuments: any;
  public ipfs: any;
  public getTokenInfo: any;
  public getDailyVolume: any;
  public getDailyHigh: any;
  public getChartData: any;
  public getOrders: any;
  public getLastTrade: any;
  public getTrades: any;
  public getActiveOrders: any;
  public getEthToUSDPrice: any;
  public getOneETHtoUSD: any;
  public getTokenBalance: any;
  public getNetwork: any;
  public getOwners: any;
  public isUsedEscrow: any;
  public getTradeTransfersEscrow: any;
  public getTokenTransfersEscrow: any;
  public getTokenTransfers: any;
  public getFinStatements: any;
  public getWaitings: any;
  public getOtherAssets: any;
  public getCompanyEthereumWallet: any;
  public getCompanyEthereumBalance: any;
  public getCompanyBitcoinWallet: any;
  public getCompanyBitcoinBalance: any;
  public getCompanyBankWallet: any;
  public getCompanyName: any;
  public getCompanyBalance: any;
  public getCompanyWallet: any;
  public getVotings: any;
  public getVotes: any;
  public getMemberAvatar: any;
  public communications: any;
  public getActiveTradesList: any;
  public getSidebarLinks: any;
  public getBalance: any;
  public getOpenClose: any;
  public getBlockNumber: any;
  public sidebarForm: any;
  public sidebarFormData: any;
  public isTreasuryWallet: any;
  public getBalances: any;
  public getMinTotal: any;

  // Actions
  public openClose: any;
  public getMembersDapp: any;
  public getTradesOfOrderDapp: any;
  public cancelMarketOrderDapp: any;
  public getChartDataExt: any;
  public getMarketCupExt: any;
  public getDailyHighExt: any;
  public getDailyVolumeExt: any;
  public clearChartData: any;
  public getOtherAssetsExt: any;
  public getVotingVotesDapp: any;
  public changeOwnerDapp: any;
  public addFirstOwnerDapp: any;
  public initiateParametersDapp: any;
  public isInitiatedTokenDapp: any;
  public closeSidebar: any;
  public initiateOwnersDapp: any;
  public addOwnersDapp: any;
  public setSideBarForm: any;
  public getStripePublicExt: any;
  public purchaseStripeExt: any;
  public addCompanyInfoDapp: any;

  //Mutations
  public initializationPending: any;
  public resetOwners: any;
}
